<div *ngIf="viewModel$ | async as viewModel">
  <div class="form-group media-devices">
    <label class="col-md-2 control-label" style="top: 85px; left: 16px; position: absolute">
      Media Types:
    </label>
    <div class="col-md-offset-2 col-md-8">
      <div class="checkbox">
        <label class="col-md-6" style="width: 250px; padding: 0">
          <p-checkbox class="form-check-input"
                      name="mediaDevices"
                      [(ngModel)] = "isSMSDevice"
                      [binary]="true"
                      (onChange)="selectedDevice($event.checked, 'sms')"></p-checkbox>
          <span style="margin-left:10px;">SMS (fragmentID: "smscontent")</span>
        </label>
        <p-dropdown
            id="smsDevice"
            [options]="viewModel.deviceSms"
            [(ngModel)]="selectedSmsDevice"
            optionLabel="deviceId"
            placeholder=""
            styleClass="form-control"
            (onChange)="selectedDevice(isSMSDevice, 'sms')"
            panelStyleClass="form-control"
            [style]="{'font-size': '13px', 'color': '#555', 'background': '#ffffff' ,'font-family':'Helvetica Neue,Helvetica,Arial,sans-serif', 'width': '120px', 'float': 'right', 'padding': '2px 1px 1px 9px', 'height':'25px'}">

        </p-dropdown>
      </div>
    </div>

    <div class="col-md-offset-2 col-md-8">
      <div class="checkbox">
        <label class="col-md-6" style="width: 250px; padding: 0">
          <p-checkbox class="form-check-input"
                      name="mediaDevices"
                      [(ngModel)] = "isEmailDevice"
                      [binary]="true"
                      (onChange)="selectedDevice($event.checked, 'email')"></p-checkbox>
          <span style="margin-left:10px;">Email (fragmentID: "emailcontent")</span>
        </label>
        <p-dropdown
            id="emailDevice"
            [options]="viewModel.devicesEmail"
            [(ngModel)]="selectedEmailDevice"
            optionLabel="deviceId"
            placeholder=""
            styleClass="form-control"
            panelStyleClass="form-control"
            (onChange)="selectedDevice(isEmailDevice, 'email')"
            [style]="{'font-size': '13px', 'color': '#555', 'background': '#ffffff' ,'font-family':'Helvetica Neue,Helvetica,Arial,sans-serif', 'width': '120px', 'float': 'right', 'padding': '2px 1px 1px 9px', 'height':'25px'}">

        </p-dropdown>
      </div>
    </div>
    <div class="col-md-offset-2 col-md-8">
      <div class="checkbox">
        <label class="col-md-6" style="width: 250px; padding: 0">
          <p-checkbox class="form-check-input"
                      name="mediaDevices"
                      [(ngModel)] = "isVoiceDevice"
                      [binary]="true"
                      (onChange)="selectedDevice($event.checked, 'voice')"></p-checkbox>
          Voice (fragmentID: "voicecontent")
        </label>
        <p-dropdown
            id="voiceDevice"
            [options]="viewModel.devicesVoice"
            [(ngModel)]="selectedVoiceDevice"
            optionLabel="deviceId"
            placeholder=""
            styleClass="form-control"
            panelStyleClass="form-control"
            (onChange)="selectedDevice(isVoiceDevice, 'voice')"
            [style]="{'font-size': '13px', 'color': '#555', 'background': '#ffffff' ,'font-family':'Helvetica Neue,Helvetica,Arial,sans-serif', 'width': '120px', 'float': 'right', 'padding': '2px 1px 1px 9px', 'height':'25px'}">

        </p-dropdown>
      </div>
    </div>
  </div> <!--.media-devices end-->
</div>
<div class="row">
  <div class="col-md-12">
    <br/>
    <p>When sending a message for a specific media type (e.g. SMS) the device defined on the template is used.
      If no device is specified for the media type on the template the account default device is used.
      If no account default specified then the system default is used.</p>
    <p>NOTE: Only specify on the template in special cases that needs to use different device(s) than the
      account/system defaults.</p>
    <p>When sending test messages it may be useful to select a different device without saving.</p>
  </div>
</div>